// extracted by mini-css-extract-plugin
export default {"padding":"ServicesListBlock_padding__oKfMY","text-header":"ServicesListBlock_text-header__wWP3O","background":"ServicesListBlock_background__bsWYy"};